import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VaultService } from 'app/services/models/vault.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-vault-vault-movement-dialog',
  templateUrl: './update-vault-vault-movement-dialog.component.html',
  styleUrls: ['./update-vault-vault-movement-dialog.component.scss']
})
export class UpdateVaultVaultMovementDialogComponent implements OnInit {
  @Input() data;
  form: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private vaultVaultMovementService: VaultService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      balance: [null, Validators.required],
      description:[null],
    });
    if (this.data) {
      this.form.patchValue({
        balance: this.data.balance,
        description:this.data.description
      });
    }
    console.log(this.data);
  }

  async save() {
    if (this.form.invalid) return;

    try {
      const balance = this.form.value.balance;
      const description = this.form.value.description;

      // ✅ Service metodunu tetikle
      const res = await this.vaultVaultMovementService.updateVaultVaultMovement(this.data.id, balance,description);
      if (res.status == true) {
        this.vaultVaultMovementService.sendEvent(true);
        this.activeModal.close(true); // modalı kapatıp true döndür
        this.toastr.success(res.message);
      }else{
        this.toastr.error(res.message);
      }
    } catch (err) {
      console.error(err);
      this.toastr.error('Güncelleme sırasında hata oluştu');
      this.activeModal.close(false);
    }
  }

  onClose(result: boolean) {
    this.activeModal.close(result);
  }
}
